module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button",
    attrs: {
      "id": "button"
    }
  }, [_c('button', {
    ref: "buttonDOM",
    class: _vm.type === 'back' || _vm.type === 'tosignup' ? 'white' : '',
    style: ({
      cursor: (!_vm.loading ? 'pointer' : 'not-allowed')
    }),
    attrs: {
      "id": "buttons"
    },
    on: {
      "click": _vm.clickBtn
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._v(_vm._s(_vm.params[_vm.type].text))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "rolling",
    attrs: {
      "src": _vm.rolling
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aa3b7b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Buttons.vue
// module id = 739
// module chunks = 1